import { render, staticRenderFns } from "./PosCartItemized.vue?vue&type=template&id=dfd13d54&scoped=true&"
import script from "./PosCartItemized.vue?vue&type=script&lang=js&"
export * from "./PosCartItemized.vue?vue&type=script&lang=js&"
import style0 from "./PosCartItemized.vue?vue&type=style&index=0&id=dfd13d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd13d54",
  null
  
)

export default component.exports